module.exports = __webpack_public_path__ + "img/t3-13.458c1e16.svg";